import { IApplicationState } from '../../../../../types/types';
import { getAuthUserMetaMyWork } from '../../../../../store/model/selectors/getAuthUserMetaMyWork';

export const getMyWorkBoardsUpdateLastSeen = (
    state: IApplicationState
): number => {
    return getAuthUserMetaMyWork(state).boardsUpdatesLastSeen;
};
